<template>
    <div class="access" :class="{'access--copy' : selectElement}">
        <div
            class="access__prop access__project-name"
            @click="copyAccess(accessData.id)"
        >{{ accessData.project_name }}</div>
        <div
            class="access__prop access__host"
            @click="copyAccess(accessData.id)"
        >{{ accessData.host }}</div>
        <div
            class="access__prop access__login"
            @click="copyAccess(accessData.id)"
        >{{ accessData.login }}</div>
        <div
            class="access__prop access__password"
            @click="copyAccess(accessData.id)"
        >{{ accessData.password }}</div>
        <div
            class="access__prop access__comment"
            @click="copyAccess(accessData.id)"
        >{{ accessData.comment }}</div>
        <div
            class="access__prop access__type"
            @click="copyAccess(accessData.type)"
        >{{ accessData.type }}</div>
        <div class="access__prop access__edit" @click="editBlockOpen = !editBlockOpen; emitClose()">
            <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="edit"
                class="svg-inline--fa fa-edit fa-w-18"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512"
            >
                <path
                    fill="currentColor"
                    d="M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"
                />
            </svg>
        </div>
        <div class="access__prop access__del" @click="popupOpen = !popupOpen">
            <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="trash"
                class="svg-inline--fa fa-trash fa-w-14"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
            >
                <path
                    fill="currentColor"
                    d="M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"
                />
            </svg>
        </div>
        <transition name="edit-form">
            <AccessItemEdit
                v-if="editBlockOpen"
                :accessData="accessData"
                @closeedit="editBlockOpen = false"
                @edit="editElement"
            />
        </transition>
        <PopUp
            :isOpen="popupOpen"
            @popupclickokay="deletElement"
            @popupclickcencel="popupOpen = false"
            text="Удалитьт элемент?"
        />
    </div>
</template>

<script>
import AccessItemEdit from "@/components/AccessItemEdit.vue";
import PopUp from "@/components/PopUp.vue";

export default {
    components: {
        AccessItemEdit,
        PopUp
    },

    props: {
        accessData: {
            default: () => {},
            type: Object
        },
        currentOpen: {
            default: () => {},
            type: Object
        }
    },

    data() {
        return {
            selectElement: false,
            editBlockOpen: false,
            popupOpen: false
        };
    },

    methods: {
        emitClose() {
            this.$emit("openedit", this.accessData);
        },
        editElement() {
            this.editBlockOpen = false;
            this.selectElement = true;
            setTimeout(() => {
                this.selectElement = false;
            }, 3000);
        },
        deletElement() {
            this.axios
                .get(`/api/del/${this.accessData.id}`)
                .then(response => {
                    this.$emit("refresh", response.data);
                    this.popupOpen = false;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        copyAccess() {
            navigator.clipboard.writeText(
                "Host: " +
                    this.accessData.host +
                    "\nLogin: " +
                    this.accessData.login +
                    "\nPassword: " +
                    this.accessData.password
            );
            this.selectElement = true;
            setTimeout(() => {
                this.selectElement = false;
            }, 3000);
        }
    },

    watch: {
        currentOpen() {
            if (this.currentOpen.id === this.accessData.id) {
                return;
            } else {
                this.editBlockOpen = false;
            }
        }
    }
};
</script>

<style lang="sass" scoped>
.access
    display: flex
    justify-content: space-between
    margin: 30px 0
    background-color: $grey-d
    text-align: center
    position: relative
    +trans(300ms,background-color)
    &:hover
        background-color: $grey-l
    &.access--copy
        background-color: $green
        color: $grey
    svg
        width: 13px
.access__prop
    padding: 15px 20px
    cursor: pointer
.access__project-name,
.access__host,
.access__login,
.access__password
    width: 15%
.access__edit
    width: 5%
    color: $green
    svg
        width: 16px
.access__del
    width: 5%
    color: $red
.access__type
    width: 10%
.access__comment
    width: 20%
.edit-form-enter-active, .edit-form-leave-active
  transition: transform 500ms, opacity 200ms
.edit-form-enter, .edit-form-leave-to
  opacity: 0
  transform: scale(1.05)
</style>